<div class="cont">
  <div class="tabs tabs-upper">
    <div class="tab-maksutavat" [class.ktab-upper-narrow]="naytaVeroilmoitusValilehtiObservable | async">
      @for (maksutapaJaKirjaukset of rivinKirjauksetMaksutavoittain(); track maksutapaJaKirjaukset; let i = $index) {
        <app-button
          (click)="vaihdaValittuMaksutapa(maksutapaJaKirjaukset)"
          [dynamicClass]="{
            'tab-valittu-sininen': maksutapaJaKirjaukset.valittu && !maksutapaJaKirjaukset.kasittelematta,
            'tab-valittu-harmaa': maksutapaJaKirjaukset.valittu && !!maksutapaJaKirjaukset.kasittelematta,
          }"
          actionId="Kirjanpito: Vaihda maksutapa"
          additionalClass="dark-gray-text ktab"
        >
          <div class="tabs-container">
            @if (maksutapaJaKirjaukset.kasittelematta) {
              <div class="tab-pallura kasittelemattaPallura" [class.mat-elevation-z1]="maksutapaJaKirjaukset.valittu">
                {{ maksutapaJaKirjaukset.kasittelematta }}
              </div>
            }
            @if (!maksutapaJaKirjaukset.kasittelematta) {
              <div class="tab-pallura" [class.harmaaPallura]="!maksutapaJaKirjaukset.valittu" [class.kasiteltyjaPallura]="maksutapaJaKirjaukset.valittu" [class.mat-elevation-z1]="maksutapaJaKirjaukset.valittu">
                {{ maksutapaJaKirjaukset.kasiteltyja || 0 }}
              </div>
            }
            {{ riviNames()[i] }}
          </div>
        </app-button>
      }
    </div>
  </div>
</div>
